import Vue from 'vue';

export default {
	namespaced: true,
	state: {
        restApiUri: 'https://api.iqquantum.com/api/',
        wssUri:'wss://api.iqquantum.com/',
        wssUri969: 'ws://api969.forexinvest.com:50011/',
        restConfApiUri: 'https://api2.iqquantum.com/api/',
        chatRestUri: 'https://chat.iqquantum.com/api/v1/',
        chatApiUri: 'wss://chat.iqquantum.com/websocket',
        newsApiUri: 'https://newsapi.org/v2/top-headlines?country=ru&category=business&apiKey=4e87afc5b31b42e594540338d355f7ce',
        blogApiUri: 'https://api.iqquantum.com/api/blog'
	},
	getters: {
		getApiUri(state) {
			return state.restApiUri;
        },
        getBlogApi(state) {
            return state.blogApiUri;
        },
        getNewsApiUri (state) {
            return state.newsApiUri
        },
        getNewsLentaApiUri (state) {
            return state.newsLentaApiUri
        },
        getNewsFTApiUri (state) {
            return state.newsFTApiUri
        },
        getNewsCCApiUri (state) {
            return state.newsCRApiUri
        },
        getWssUri(state) {
			return state.wssUri;
        },
        getWssUri969(state) {
			return state.wssUri969;
        },
        getConfApiUri(state) {
            return state.restConfApiUri;
        },
        getChatRestUri(state) {
			return state.chatRestUri;
        },
        getChatApiUri(state) {
			return state.chatApiUri;
		},
	},
	actions: {
	}
}
